import React, { createContext, useContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
 const [isAuthenticated, setIsAuthenticated] = useState(false);
 const [user, setUser] = useState(null);
 const [role, setRole] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 const token = localStorage.getItem('app-token');
 const userData = localStorage.getItem('app-user');
 if (token && userData) {
 const parsedUser = JSON.parse(userData);
    setIsAuthenticated(true);
    setUser(parsedUser);
    setRole(parsedUser.role);
 }
 setLoading(false);
 }, []);

 const login = (token, userData) => {
 localStorage.setItem('app-token', token);
 localStorage.setItem('app-user', JSON.stringify(userData));
 setIsAuthenticated(true);
 setUser(userData);
 setRole(userData.role);
 };

 const logout = () => {
 localStorage.removeItem('app-token');
 localStorage.removeItem('app-user');
 setIsAuthenticated(false);
 setUser(null);
 setRole(null);
 };

 return (
 <AuthContext.Provider
 value={{
 isAuthenticated,
 user,
 role,
 login,
 logout,
 loading,
 }}
 >
 {children}
 </AuthContext.Provider>
 );
};

export const useAuth = () => {
 const context = useContext(AuthContext);
 if (!context) {
 throw new Error('useAuth must be used within an AuthProvider');
 }
 return context;
};
